import profileImg from "@/assets/tryDemo.webp"
import { useNavigate } from "react-router-dom";
const RequestDemo = ({ contactUs }: { contactUs: () => void }) => {
  const navigate = useNavigate()
  return (
    <section className="bg-[#F5FAF9] relative h-auto md:h-[420px] px-4 md:px-0 overflow-visible">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-10 py-10 md:py-0 h-auto md:h-full relative">

        {/* Left Content */}
        <div className="w-full md:w-1/2">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug text-left">
            Ready to take your hiring process to the next level?
          </h1>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug text-left mt-3">
            {/* Optional second line if needed */}
          </h1>

          <p className="mt-6 sm:mt-8 text-base sm:text-lg text-gray-700 text-left">
            See for yourself how <b>Talentick.ai's </b> all-in-one hiring solution helps you and your team streamline recruitment, reduce hiring time, and make data-backed decisions at scale.
          </p>

          <div className="mt-6 sm:mt-8 flex flex-wrap gap-4">

            <button onClick={() => navigate("/register")} className="bg-black text-white px-6 sm:px-8 py-3 rounded-full font-medium hover:scale-110 transition-all">
              Try for Free
            </button>
            <button
              className="border border-black text-black px-6 py-3 rounded-full font-medium hover:scale-110 transition-all"
              onClick={contactUs}
            >
              Schedule a Demo
            </button>
          </div>
        </div>

        {/* Right Image — comes first on mobile */}
        <div className="w-full md:w-auto flex justify-center relative z-10">
          <img
            src={profileImg}
            alt="Candidate"
            className="h-[300px] md:h-[500px] mt-[-100px] md:mt-[-80px]"
          />
        </div>
      </div>
    </section>





  );
};


export default RequestDemo